import React from "react";
import "./policy_terms.css";

const PrivacyPolicy = () => {
  return (
    <div className="pt-container">
      <img src="/blur.jpg" alt="Bus" className="blur-image" />
      <div className="pt-content">
        <h1 className="pt-heading">EVIDE BUS PRIVACY POLICY</h1>

        <section className="pt-section">
          <h2 className="pt-subheading">Introduction</h2>
          <p>
          EVIDE BUS is committed to transparency and does not collect any personal information from visitors. This Privacy Policy explains the handling of publicly available bus information.
          </p>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Information Collection</h2>
          <p>EVIDE BUS does not collect any personal information from users. Specifically:</p>
          <ul>
            <li>No registration, login, or user accounts are required.</li>
            <li>We do not collect names, email addresses, phone numbers, payment details, or any other personal data.</li>
            <li>All bus-related information (bus names, numbers, available days, stops, and timetables) is publicly available data displayed for your convenience.</li>
          </ul>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Use of Information</h2>
          <ul>
            <li>Searching buses by route or stop</li>
            <li>Displaying bus details, schedules, and available days</li>
          </ul>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Data Sharing</h2>
          <p>EVIDE BUS does not share or sell any personal information, as no personal data is collected.</p>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Cookies and Tracking</h2>
          <p>Our web application does not use cookies, tracking scripts, or analytics to monitor user activity.</p>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Data Security</h2>
          <p>As no personal information is collected or stored, there is no risk of data breaches related to user privacy.</p>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Changes to Privacy Policy</h2>
          <p>
            We may update this Privacy Policy occasionally to reflect improvements or
            changes to the service. Updates will be posted on this page. Continued use
            of EVIDE BUS constitutes acceptance of any changes.
          </p>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Contact Information</h2>
          <p>
            For questions or concerns regarding this Privacy Policy,please email us at: <a href="mailto: contact@evidebus.info"> contact@evidebus.info</a>
          </p>
         
        </section>

        {/* <p className="pt-effective-date">Effective Date: 03/10/2025</p> */}
      </div>
    </div>
  );
};

export default PrivacyPolicy;

